import { cva } from "class-variance-authority";

export const reviewStatusVariants = cva(
  `rounded-lg text-center border-none px-2 py-0.5`,
  {
    variants: {
      type: {
        helpful: "min-w-11 bg-[#F0F7FF] text-[#235DF4]",
        unhelpful: "min-w-20 bg-[#FFF1F0] text-[#F5222D]",
      },
    },
  },
);
